export default {
	"searchDemo": {
		"searchBy": "ค้นหา",
		"searchKey": "ค้นหาคำ",
		"searchKeyList": "คำที่ค้นหาบ่อย",
		"account": "บัญชี",
		"device": "อุปกรณ์ติดตาม",
		"users": "บุคลากร",
		"capacity": "ขีดความสามารถ",
		"hotKeyList": "คำใกล้เคียงที่พบบ่อย",
		"mobile": "หมายเลขติดต่อ",
		"hotKeyMoreList": "คำที่ต้องรู้แบบหลายมิติ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/search/search.js